var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPharmacyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "64px",
    width: "64px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 35.219 35.219",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006737"
    },
    d: "M17.612,0C11.005,0,5.647,5.321,5.647,11.885c0,3.358,3.295,9.374,3.295,9.374l8.229,13.96 l8.586-13.797c0,0,3.814-5.74,3.814-9.537C29.572,5.321,24.216,0,17.612,0z M17.555,18.431c-3.783,0-6.848-3.065-6.848-6.853 c0-3.783,3.064-6.846,6.848-6.846c3.781,0,6.851,3.063,6.851,6.846C24.406,15.366,21.336,18.431,17.555,18.431z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#006737"
    },
    points: "18.982,7.406 16.277,7.406 16.277,10.487 13.128,10.487 13.128,13.193 16.277,13.193 16.277,16.367 18.982,16.367 18.982,13.193 22.09,13.193 22.09,10.487 18.982,10.487 "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacyIcon);
export default __webpack_public_path__ + "static/media/pharmacyIcon.b137394f2873e7d0f6fcf0edb794bf39.svg";
export { ForwardRef as ReactComponent };